import { render, staticRenderFns } from "./servicos.vue?vue&type=template&id=361daae4&scoped=true&"
var script = {}
import style0 from "./servicos.vue?vue&type=style&index=0&id=361daae4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361daae4",
  null
  
)

export default component.exports